var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useMemo } from 'react';
import { Translate } from "../../../../../../../../../I18N";
import { Select } from "../../../../../../../../Components/Forms";
import { useAtomValue } from 'jotai';
import { relationshipTypesAtom, templatesAtom } from "../../../../../../../../atoms";

import { useCreateExtractorContext } from "../../CreateExtractorContext";

const getOptions = (options) => [
{
  key: `select-${Math.random().toString()}`,
  value: '',
  label: 'Select...'
},
...options];


const getTemplateProperties = (
type,
targetTemplate) =>

targetTemplate !== null && targetTemplate !== void 0 && targetTemplate.properties ?
targetTemplate.properties.
filter((property) => property.type === type).
map((property) => {var _property$_id, _property$_id$toStrin, _property$_id2;return {
    key: (_property$_id = property._id) === null || _property$_id === void 0 ? void 0 : _property$_id.toString(),
    value: (_property$_id$toStrin = (_property$_id2 = property._id) === null || _property$_id2 === void 0 ? void 0 : _property$_id2.toString()) !== null && _property$_id$toStrin !== void 0 ? _property$_id$toStrin : '',
    label: property.label
  };}) :
[];

const Body = () => {
  const {
    targetTemplateId,
    paragraphPropertyId,
    paragraphNumberPropertyId,
    targetRelationshipId,
    sourceRelationshipId,
    setParagraphPropertyId,
    setParagraphNumberPropertyId,
    setTargetRelationshipId,
    setSourceRelationshipId
  } = useCreateExtractorContext();
  const templates = useAtomValue(templatesAtom);
  const relationTypes = useAtomValue(relationshipTypesAtom);
  const targetTemplate = templates.find((template) => template._id === targetTemplateId);

  const richTextProperties = useMemo(
    () => getTemplateProperties('markdown', targetTemplate),
    [targetTemplate]
  );
  const numericProperties = useMemo(
    () => getTemplateProperties('numeric', targetTemplate),
    [targetTemplate]
  );
  const relationships = useMemo(
    () =>
    relationTypes.map((relation) => ({
      key: relation._id,
      value: relation._id,
      label: relation.name
    })),
    [relationTypes]
  );

  return (/*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4 min-h-[400px] my-4" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Select, {
      id: "rich-text-property",
      label: /*#__PURE__*/
      _jsx(Translate, { className: "text-sm font-semibold text-gray-900" }, void 0, "Paragraph text extraction property (rich text)"

      ),

      value: paragraphPropertyId,
      options: getOptions(richTextProperties),
      onChange: (evt) => {
        setParagraphPropertyId(evt.target.value);
      } }
    )
    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Select, {
      id: "numeric-text-property",
      label: /*#__PURE__*/
      _jsx(Translate, { className: "text-sm font-semibold text-gray-900" }, void 0, "Paragrap number extraction property (numeric)"

      ),

      value: paragraphNumberPropertyId,
      options: getOptions(numericProperties),
      onChange: (evt) => {
        setParagraphNumberPropertyId(evt.target.value);
      } }
    )
    ), /*#__PURE__*/
    _jsx("hr", { className: "self-center w-5 my-4 border-t-2 border-gray-200" }), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Select, {
      id: "target-relationship-type",
      label: /*#__PURE__*/
      _jsx("div", { className: "flex flex-col gap-1" }, void 0, /*#__PURE__*/
      _jsx(Translate, { className: "text-sm font-semibold text-gray-900" }, void 0, "Target relationship type"

      ), /*#__PURE__*/
      _jsx(Translate, { className: "text-sm font-light text-gray-500" }, void 0, "Target's role in the relationship Source-Target."

      )
      ),

      value: targetRelationshipId,
      options: getOptions(
        relationships.filter((relation) => relation.value !== sourceRelationshipId)
      ),
      onChange: (evt) => {
        setTargetRelationshipId(evt.target.value);
      } }
    )
    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Select, {
      id: "source-relationship-type",
      label: /*#__PURE__*/
      _jsx("div", { className: "flex flex-col gap-1" }, void 0, /*#__PURE__*/
      _jsx(Translate, { className: "text-sm font-semibold text-gray-900" }, void 0, "Source relationship type"

      ), /*#__PURE__*/
      _jsx(Translate, { className: "text-sm font-light text-gray-500" }, void 0, "Source's role in the relationship Source-Target."

      )
      ),

      value: sourceRelationshipId,
      options: getOptions(
        relationships.filter((relation) => relation.value !== targetRelationshipId)
      ),
      onChange: (evt) => {
        setSourceRelationshipId(evt.target.value);
      } }
    )
    )
    ));

};

export { Body };